import { Checkbox, FormControlLabel } from "@mui/material";
import { pink } from "@mui/material/colors";
import { useState } from "react";


 const DeliveryInformation = () => {
  const [page, setPage] = useState("");
    
  const submitHandler = () => {
    if(page < 4 ){   
       setPage((currpage) => {
           // const cont = ; 
          //  typesHandler(currpage);
           return currpage + 1;
       });
       
    }
   }

 return(
 <>
   {page == 1 &&
  <div className="outer-wrapper my-[3rem]">
  <div className="inner-wrapper sm:flex block flex-col justify-center items-center mt-[1rem]  ">
    <div className="flex flex-col gap-3 p-8 px- shadow-card text-sm md:w-[53rem] sm:w-[40rem] w-[auto] mx-[1rem] rounded-md transition-all duration-500">
      <div className=" grid">
        <h2 className="font-bold text-[1.1rem] leading-5">Delivery Information</h2>
        <FormControlLabel  
          control={<Checkbox Checked sx={{'&.Mui-checked': {color: pink[600]},}} />} 
          label={<p className="text-sm">Same as shipper information</p>} 
        />
      </div>

      <div className="sm:flex grid gap-4">
        <div className="MuiFormControl-root MuiTextField-root flex-1">
          <div className="relative w-[24rem]">
            <input
              type="text"
              id="floating_outlined"
              className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
              placeholder=" "
            />
            <label
              for="floating_outlined"
              className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
            >Name <span className="text-[#F21E26]">*</span>
            </label>
          </div>
        </div>
        <div className="MuiFormControl-root MuiTextField-root flex-1">
          <div className="relative w-[24rem]">
            <input
              type="text"
              id="floating_outlined"
              className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
              placeholder=" "
            />
            <label
              for="floating_outlined"
              className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
            >Email <span className="text-[#F21E26]">*</span>
            </label>
          </div>
        </div>
      </div>

      <div className="sm:flex grid gap-4">
        <div className="MuiFormControl-root MuiTextField-root flex-1">
          <div className="relative w-[24rem]">
            <input
              type="text"
              id="floating_outlined"
              className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
              placeholder=" "
            />
            <label
              for="floating_outlined"
              className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
            >
              Mobile Number <span className="text-[#F21E26]">*</span>
            </label>
          </div>
        </div>
          
        <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
          <div className="relative">
            <select id="floating_outline" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" ">
              <option>Country</option>
              <option>1</option>
              <option>2</option>
              <option>3</option>
            </select>
            <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
              Country
            </label>
          </div>
        </div>
      </div>

      <div className="sm:flex grid gap-4">
        <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
          <div className="relative">
            <select id="floating_outline" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" ">
              <option>City</option>
              <option>1</option>
              <option>2</option>
              <option>3</option>
            </select>
            <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
              City
            </label>
          </div>
        </div>
        <div className="MuiFormControl-root MuiTextField-root flex-1">
          <div className="relative w-[24rem]">
            <input
              type="text"
              id="floating_outlined"
              className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
              placeholder=" "
            />
            <label
              for="floating_outlined"
              className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
            >
             Postcode
            </label>
          </div>
        </div>
      </div>

      <div className="sm:flex grid gap-4">
        <div className="MuiFormControl-root MuiTextField-root flex-1">
          <div className="relative w-[49rem]">
            <input
              type="text"
              id="floating_outlined"
              className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
              placeholder=" "
            />
            <label
              for="floating_outlined"
              className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
            >
              Address <span className="text-[#F21E26]">*</span>
            </label>
          </div>
        </div>
        

      </div>

      <div className="sm:flex grid gap-4 ">
        <div className="MuiFormControl-root MuiTextField-root flex-1">
          <button className="text-[#F21E26]  h-[2.5rem] border border-[#F21E26] w-[100%] sm:w-[24rem]  rounded-md  p-1 text-sm  transition-all duration-500">
            Previous
          </button>
          <button onClick={submitHandler}
             className="text-white bg-[#D40511] h-[2.5rem] border border-[#F21E26] w-[100%] sm:w-[24rem] ml-[1rem]  rounded-md  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">
            Next
          </button>
        </div>
      </div>
          
        
    </div>
  </div>
  </div>
    }



</>
)};
export default DeliveryInformation;